import { Swiper } from 'swiper/bundle';

var testimonialSlider = document.querySelector('.slider-testimonial');
if (testimonialSlider) {
  initializeSwiper(testimonialSlider);
}

function initializeSwiper(swiperInstance) {
  new Swiper(swiperInstance, {
    navigation: {
      disabledClass: 'slider-control-disabled',
      hiddenClass: 'slider-control-hidden',
      lockClass: 'slider-control-lock',
      nextEl: swiperInstance.querySelector('.slider-control-next'),
      prevEl: swiperInstance.querySelector('.slider-control-prev'),
    },
    on: {
      init: function () {
        var pagerCurent = this.el.querySelector('.slider-pager-numbers > .slider-pager-current'),
          pagerTotal = this.el.querySelector('.slider-pager-numbers > .slider-pager-total');
        pagerCurent.innerHTML = '0' + (this.activeIndex + 1);
        pagerTotal.innerHTML = '0' + this.slides.length;
      },
      slideChange: function () {
        var currentSlide = '0' + (this.realIndex + 1);
        this.el.querySelector('.slider-pager-numbers > .slider-pager-current').innerHTML =
          currentSlide;
      },
    },
    effect: 'fade',
    crossFade: true,
    speed: 500,
    slidesPerView: 1,
    slideActiveClass: 'slider-item-active',
  });
}

export { initializeSwiper };
